import { render, staticRenderFns } from "./onlinePrompt.vue?vue&type=template&id=577c4002"
import script from "./onlinePrompt.vue?vue&type=script&lang=js"
export * from "./onlinePrompt.vue?vue&type=script&lang=js"
import style0 from "./onlinePrompt.vue?vue&type=style&index=0&id=577c4002&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/panzhijing/蛋卷科技/danjuan-admin/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577c4002')) {
      api.createRecord('577c4002', component.options)
    } else {
      api.reload('577c4002', component.options)
    }
    module.hot.accept("./onlinePrompt.vue?vue&type=template&id=577c4002", function () {
      api.rerender('577c4002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/placeOrder/components/onlinePrompt.vue"
export default component.exports